import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Worker desde CDN matcheando la versión instalada — mismo patrón que src/utils/pdf/extraerTextoPdf.js
// / parseSwiftPdf.js (10.243: cada dominio de parseo PDF trae su propia copia del setup del worker;
// no hay una dependencia viva compartida que romper).
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`;

/**
 * Extracción de texto de un PDF, 100% en cliente (no sube el archivo), PRESERVANDO saltos de línea
 * por fila visual — a propósito DISTINTA de `src/utils/pdf/extraerTextoPdf.js` (que une TODOS los
 * items de una página con un solo espacio, sin `\n`). `parsearLiquidacionTexto.js` depende de que
 * cada línea del PDF (ej. "Total Haberes ... 1.866.086") empiece tras un `\n` real — sus regex usan
 * `\n[ \t]*Total ...` para distinguir la línea de resumen limpia de "Total Haberes Tributables e
 * Imponibles" (que NO debe matchear). El extractor flat-join no sirve para este parser.
 *
 * Algoritmo: agrupa los `items` de `getTextContent()` por su coordenada Y (tolerancia ±2pt — items
 * de una misma fila visual comparten baseline), ordena las filas de arriba a abajo (Y descendente,
 * el eje Y de PDF crece hacia arriba) y, dentro de cada fila, los items de izquierda a derecha (X
 * ascendente), uniéndolos con un espacio. Verificado carácter a carácter contra `pdftotext -layout`
 * (el extractor que usa el script de dry-run/carga) sobre los 27 PDF reales: mismos 27/27 parseados
 * OK, mismos montos exactos — ver docs/decisiones/2026-09-28-liquidaciones-contadora-fase-c.md.
 *
 * @param {File} file
 * @returns {Promise<string>}
 */
export const extraerTextoLiquidacionPdf = async (file) => {
  const buffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
  let texto = "";
  for (let i = 1; i <= pdf.numPages; i++) {
    // eslint-disable-next-line no-await-in-loop
    const page = await pdf.getPage(i);
    // eslint-disable-next-line no-await-in-loop
    const content = await page.getTextContent();

    const filas = new Map(); // y (redondeada, agrupada por tolerancia) → items[]
    for (const item of content.items) {
      if (!item.str || item.str.trim() === "") continue;
      const y = Math.round(item.transform[5]);
      let claveFila = null;
      for (const y0 of filas.keys()) {
        if (Math.abs(y0 - y) <= 2) {
          claveFila = y0;
          break;
        }
      }
      if (claveFila === null) claveFila = y;
      if (!filas.has(claveFila)) filas.set(claveFila, []);
      filas.get(claveFila).push(item);
    }

    const filasOrdenadas = [...filas.entries()].sort((a, b) => b[0] - a[0]);
    for (const [, items] of filasOrdenadas) {
      const linea = items
        .sort((a, b) => a.transform[4] - b.transform[4])
        .map((it) => it.str)
        .join(" ");
      texto += `${linea}\n`;
    }
  }
  return texto;
};
